import {useEffect, useState, useRef, useLayoutEffect, useCallback} from 'react'

import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {getDailyProfitorloss} from '../apis/Loadalltabledata'
import {KTCard} from '../../_metronic/helpers'
import {KTCardBody} from '../../_metronic/helpers'
import {KTSVG, toAbsoluteUrl} from '../../_metronic/helpers'
import {Maintable} from '../tables/Maintable'
import {useMemo} from 'react'
import LoadingBar from 'react-top-loading-bar'
import {useWindowWidth} from '@react-hook/window-size/throttled'
import {
  useDailyprofitorlossusequery,
  useDailyprofitorlossusequery2,
  useAllexpenses,
} from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import '../css/popover.css'
import {Column} from 'react-table'
import {useAuth} from '../../app/modules/auth'
import {ItemsSummary} from '../topdashboard/ItemsSummary'
import {useMutation, useQueryClient} from 'react-query'
import io from 'socket.io-client'
import {Getfirsttwowords, Getnumbersinstring} from '../helpers/useStringhelper'
import { useDashboard } from '../contextProviders/Dashboardcontext'
import useNumberSequence from '../helpers/useKeySequence'
import useAggregatedData from '../helpers/useAggregatedData'
import useDataTrend from '../helpers/useDataTrend'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween);

const moment = require('moment-timezone')
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const PIC_QUANTITIES = process.env.REACT_APP_QUANTITIES_PICS
// Hook

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/home',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const socket = io('possocket.27mirrors.com')
const truncate = require('truncate')
const isNegative = (num: any) => Math.sign(num) === -1

const Home = () => {
  const refloadingbar: any = useRef(null)
  const queryClient = useQueryClient()
  const myRefsearch: any = useRef()

  const {currentUser, logout} = useAuth()
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimit, setStartlimit] = useState<number>(0)

  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [itemto_order, setItemto_order] = useState<string>('datesoldnow')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [serversort, setServersort] = useState<any>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)

  const [sumprofitorlossdatanew, setSumprofitorlossdatanew] = useState<any>([])
  const { showDashboard, toggleDashboard } = useDashboard();
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<any>(['date_end', 'expenses_info'])
  const onlyWidth = useWindowWidth()
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)

  const profit_or_loss: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_profit,
      }))
  ).map((x: any) => x.totals_sum)

  const profit_or_loss2: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_profit,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_profit_or_loss: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_profit,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_profit_or_loss2: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_profit,
      }))
  ).map((x: any) => x.totals_sum)

  const gross_profit_or_loss_date: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_profit,
      }))
  ).map((x: any) => x.month)

  const gross_profit_or_loss_date2: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_profit,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const profit_or_loss_date: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_profit,
      }))
  ).map((x: any) => x.month)

  const profit_or_loss_date2: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.net_profit,
      }))
  ).map((x: any) => x.month + ', ' + x.year)

  const expenses_made: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.totals_sum)

  const expenses_made2: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.totals_sum)

  const expenses_made_date: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.month)

  const expenses_made_date2: any = useAggregatedData(
    sumprofitorlossdatanew
      .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
      .map((item: any) => ({
        datesoldnow: item.datesoldnow,
        occurrences: item.occurrences,
        hours_selling: item.hours_selling,
        totals: item.gross_expenses,
      }))
  ).map((x: any) => x.month + ', ' + x.year)



  const {
    isLoading: dailyprofitlossisloading,
    isSuccess: dailyprofitlossssuccess,
    data: dailyprofitlossdata,
    isPreviousData: dailyprofitlossispreviousdata,
    status: dailyprofitlossstatus,
    refetch: dailyprofitlossrefetch,
    isRefetching: dailyprofitlossrefetching,
  } = useDailyprofitorlossusequery(
    Number(currentUser?.user_id),
    'PAID',
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    startlimit,
    paginationsize,
    itemto_order,
    desorasc,
    search_item
  )

  const {
    isLoading: dailyprofitlossisloading2,
    isSuccess: dailyprofitlossssuccess2,
    data: dailyprofitlossdata2,
    isPreviousData: dailyprofitlossispreviousdata2,
    status: dailyprofitlossstatus2,
    isRefetching: dailyprofitlossrefetching2,
    refetch: dailyprofitlossrefetch2,
  } = useDailyprofitorlossusequery2(
    Number(currentUser?.user_id),
    'PAID',
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    0,
    366,
    'datesoldnow',
    'DESC',
    '%'
  )

  const tabledata = useMemo(
    () => dailyprofitlossdata?.data.dailyprofitorloss,
    [dailyprofitlossdata?.data.dailyprofitorloss, dailyprofitlossssuccess]
  )
 

  const tabledata3 = useMemo(
    () => dailyprofitlossdata2?.data.dailyprofitorloss,
    [dailyprofitlossdata2?.data.dailyprofitorloss, dailyprofitlossssuccess2]
  )
  const tabledatalength = useMemo(
    () => dailyprofitlossdata?.data.datalength,
    [dailyprofitlossdata?.data.datalength, dailyprofitlossssuccess]
  )

  const tablename = 'Expenses Summary'

  const filteredsubdata = (rowdata: any): number => {

    return rowdata.values.expenses_info.length;
  }
  const filteredtablesubData = (rowdata: any): any => {
    return rowdata.values.expenses_info.sort((a: any, b: any) => (a.date_expense_made > b.date_expense_made ? -1 : 1))
  }

  const profitTrend = useDataTrend(tabledata3)

  useEffect(() => {
    if (!dailyprofitlossrefetching2 && dailyprofitlossssuccess2) {
      if (
        dayjs(
          dayjs(
            dailyprofitlossdata2?.data.dailyprofitorloss
              .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
              .map((x: any) => x.datesoldnow)[0]
          ).format('YYYY-MM-DD')
        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
      ) {
        setSumprofitorlossdatanew(dailyprofitlossdata2?.data.dailyprofitorloss)
      } else {
        if (
          dayjs(
            dayjs(
              dailyprofitlossdata2?.data.dailyprofitorloss
                .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                .map((x: any) => x.datesoldnow)[0]
            ).format('YYYY-MM-DD')
          ).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() <=
            dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
        ) {
          setSumprofitorlossdatanew(dailyprofitlossdata2?.data.dailyprofitorloss)
        } else {
          const currentitemsobj2: any = {
            datesoldnow: dayjs().format('YYYY-MM-DD'),
            date_start: dayjs().format('YYYY-MM-DD'),
            date_end: dayjs().format('YYYY-MM-DD'),
            occurrences: 0,
            hours_selling: 0,
            net_profit: 0,
            gross_profit: 0,
            gross_expenses: 0,
          }

          setSumprofitorlossdatanew([
            ...dailyprofitlossdata2?.data.dailyprofitorloss,
            currentitemsobj2,
          ])
        }
      }
    }
  }, [dailyprofitlossssuccess2, dailyprofitlossrefetching2])

  useEffect(() => {
    if (dailyprofitlossssuccess2) {
      setStatusnow(true)
    } else {
      setStatusnow(false)
    }
  }, [dailyprofitlossssuccess2])

  useEffect(() => {
    if (statusnow && !dailyprofitlossrefetching2) {
      setStatusnow2(true)
    } else {
      setStatusnow2(false)
    }
  }, [dailyprofitlossrefetching2])

  useEffect(() => {
    if (!dailyprofitlossispreviousdata) {
      ;(async () => {
        await refloadingbar.current?.continuousStart()
        queryClient.prefetchQuery(
          ['dailyprofitorlossusequery', startlimit + paginationsize, paginationsize],
          () =>
            getDailyProfitorloss(
              Number(currentUser?.user_id),
              'PAID',
              new Date(dayjs
                .unix(dayjs(dayjs().startOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              new Date(dayjs
                .unix(dayjs(dayjs().endOf('year').format('YYYY-MM-DD') + OPENING_TIME).unix())
                .format('YYYY-MM-DD hh:mm')),
              startlimit + paginationsize,
              paginationsize,
              itemto_order,
              desorasc,
              search_item
            )
        )
      })().finally(refloadingbar.current.complete())
    }
  }, [
    dailyprofitlossispreviousdata,
    startlimit,
    paginationsize,
    queryClient,
    itemto_order,
    desorasc,
    search_item,
  ])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await refloadingbar.current?.continuousStart();
        await dailyprofitlossrefetch();
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current.complete();
      }
    };
    fetchData();
  }, [itemto_order, desorasc, search_item]);
  

  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
      }
    }

    const refSearch = myRefsearch.current;
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange);
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange);
      }
    }
  }, []);

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort.map((x: any) => x.id)[0])
      setDesorasc(serversort.map((x: any) => x.desc)[0] ? 'DESC' : 'ASC')
    } else {
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
    }
  }, [serversort])

  const handlesearchKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      const inputValue = event.target.value;
      if (inputValue) {
        setSearch_item(inputValue + '%');
      } else {
        setSearch_item('%');
      }
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
    }
  };
  
  const handleinputs = (event: any) => {
    if (myRefsearch.current.value === '' || event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
    }
  }

  const handlesearchKeyDown2 = (event: any) => {
    event.preventDefault()
    const inputValue = myRefsearch.current.value || event.target.value;
  
    if (inputValue) {
      setSearch_item(inputValue + '%');
    } else {
      setSearch_item('%');
    }
  
      setPaginationsize(10)
      setStartlimit(0)
      setMovetofirstpage(true)
      setItemto_order('datesoldnow')
      setDesorasc('DESC')
  }
  socket.on('update', (_arg: any) => {
    ;(async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await dailyprofitlossrefetch2()
        await dailyprofitlossrefetch()
        
      } catch (error) {
        console.log(error)
      } finally {
        await refloadingbar.current?.complete()
      }
    })()
  })




  const columndata1: ReadonlyArray<
    Column<{
      datesoldnow: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      net_profit: number
      gross_profit: number
      gross_expenses: number
      profit_trend: number
      expenses_info: Array<number | string>
    }>
  > = [
    {
      Header: () => null,
      id: 'expander',

      Cell: ({row}: any) => {
        return (
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? (
              <>
                <span className='svg-icon svg-icon-primary'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              </>
            ) : (
              <>
                <span className='svg-icon svg-icon-primary'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              </>
            )}
          </span>
        )
      },
    },
    {
      Header: 'Date',
      accessor: 'date_start', // accessor is the "key" in the data

      Cell: ({cell: {value}, row}) => {
        return (
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-60px me-5'>
              <span className='svg-icon svg-icon-primary svg-icon-3x'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='21'
                  fill='none'
                  viewBox='0 0 20 21'
                >
                  <path
                    fill='currentColor'
                    d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                    opacity='0.3'
                  ></path>
                  <path
                    fill='currentColor'
                    d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                  ></path>
                </svg>
              </span>
            </div>

            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
              </span>
              <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
              </span>
            </div>
          </div>
        )
      },
    },

    {
      Header: 'E.Sales',
      accessor: 'date_end',

      Cell: ({cell: {value}}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
            {dayjs(value).format('LL')}
          </span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
          </span>
        </>
      ),
    },

    {
      Header: 'Entries',
      accessor: 'occurrences',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            {row.original.hours_selling} Hours
          </span>
        </>
      ),
    },
    {
      Header: 'expenses_info',
      accessor: 'expenses_info',

    },
    {
      Header: 'G.Profit',
      accessor: 'gross_profit',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
            <>
              {isNegative(value) ? (
                <span className='text-danger'>
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}
                </span>
              ) : (
                <span>
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                </span>
              )}
            </>
          </span>
          <span className='text-nowrap fw-bold text-muted d-block fs-7'>
            <span className='badge badge-light-danger'>
              {addCommas(row.original.gross_expenses.toFixed(2))} {CURRENCY_APP}
            </span>
          </span>
        </>
      ),
    },
    {
      Header: 'N.Profit',
      accessor: 'net_profit',

      Cell: ({cell: {value}, row}) => (
        <>
          {isNegative(value) ? (
            <span className='text-nowrap'>
              {isNegative(row.original.profit_trend) ? (
                <i className='fa fa-arrow-down text-danger'></i>
              ) : row.original.profit_trend === 0 ? (
                <i className='fa fa-arrow-up text-primary'></i>
              ) : (
                <i className='fa fa-arrow-up text-success'></i>
              )}{' '}
              <span className='badge badge-light-danger'>
                <span className='text-nowrap fs-7'>
                  {' '}
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}
                </span>
              </span>
            </span>
          ) : (
            <span className='text-nowrap'>
              {isNegative(row.original.profit_trend) ? (
                <i className='fa fa-arrow-down text-danger'></i>
              ) : row.original.profit_trend === 0 ? (
                <i className='fa fa-arrow-up text-primary'></i>
              ) : (
                <i className='fa fa-arrow-up text-success'></i>
              )}{' '}
              <span className='badge badge-light-success'>
                <span className='text-nowrap fs-7'>
                  {' '}
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}
                </span>
              </span>
            </span>
          )}
        </>
      ),
    },
  ]
  const columndata2: ReadonlyArray<
    Column<{
      expense_id: number
      expense_amount: number
      expense_name: string
      date_expense_made: string
    }>
  > = [
    {
      Header: 'id',
      accessor: 'expense_id',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
        </>
      ),
    },

    {
      Header: 'Date',
      accessor: 'date_expense_made',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
            {dayjs(value).format('LL')}
          </span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
          </span>
        </>
      ),
    },
    {
      Header: 'Name',
      accessor: 'expense_name',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.expense_name}>
            {truncate(row.original.expense_name, 20)}
          </span>
        </>
      ),
    },

    {
      Header: 'Amount',
      accessor: 'expense_amount',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {' '}
            {addCommas(value.toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
  ]

  // less than 420

  const columndata3: ReadonlyArray<
    Column<{
      datesoldnow: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      net_profit: number
      gross_profit: number
      gross_expenses: number
      profit_trend: number
      expenses_info: Array<number | string>
    }>
  > = [
    {
      Header: () => null,
      id: 'expander',

      Cell: ({row}: any) => {
        return (
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? (
              <>
                <span className='svg-icon svg-icon-primary'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              </>
            ) : (
              <>
                <span className='svg-icon svg-icon-primary'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              </>
            )}
          </span>
        )
      },
    },
    {
      Header: 'Date',
      accessor: 'date_start', // accessor is the "key" in the data

      Cell: ({cell: {value}, row}) => {
        return (
          <div className='d-flex align-items-center'>
            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                {dayjs(value).format('MMM')} {dayjs(value).format('DD')} -{' '}
                {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
              </span>
              <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                {dayjs(value).format('LT')} - {dayjs(row.original.date_end).format('LT')}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: 'E.Sales',
      accessor: 'date_end',

      Cell: ({cell: {value}}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
            {dayjs(value).format('LL')}
          </span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
          </span>
        </>
      ),
    },
    {
      Header: 'expenses_info',
      accessor: 'expenses_info',

    },

    {
      Header: 'N.Profit',
      accessor: 'net_profit',

      Cell: ({cell: {value}, row}) => (
        <>
          {isNegative(value) ? (
            <>
              <span className='text-nowrap'>
                {isNegative(row.original.profit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.profit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            </>
          ) : (
            <>
              <span className='text-nowrap'>
                {isNegative(row.original.profit_trend) ? (
                  <i className='fa fa-arrow-down text-danger'></i>
                ) : row.original.profit_trend === 0 ? (
                  <i className='fa fa-arrow-up text-primary'></i>
                ) : (
                  <i className='fa fa-arrow-up text-success'></i>
                )}{' '}
                <span className='badge badge-light-success'>
                  <span className='text-nowrap fs-7'>
                    {' '}
                    {addCommas(value.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </span>
            </>
          )}
        </>
      ),
    },
  ]

  const columndata4: ReadonlyArray<
    Column<{
      expense_id: number
      expense_amount: number
      expense_name: string
      date_expense_made: string
    }>
  > = [
    {
      Header: 'Name',
      accessor: 'expense_name',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.expense_name}>
            {truncate(row.original.expense_name, 20)}
          </span>
        </>
      ),
    },

    {
      Header: 'Amount',
      accessor: 'expense_amount',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {' '}
            {addCommas(value.toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
  ]

  //less than 420

  //less than 730 but more than 420
  const columndata5: ReadonlyArray<
    Column<{
      datesoldnow: string
      date_start: string
      date_end: string
      occurrences: number
      hours_selling: number
      net_profit: number
      gross_profit: number
      gross_expenses: number
      profit_trend: number
      expenses_info: Array<number | string>
    }>
  > = [
    {
      Header: () => null,
      id: 'expander',

      Cell: ({row}: any) => {
        return (
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? (
              <>
                <span className='svg-icon svg-icon-primary'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              </>
            ) : (
              <>
                <span className='svg-icon svg-icon-primary'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    xmlnsXlink='http://www.w3.org/1999/xlink'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              </>
            )}
          </span>
        )
      },
    },
    {
      Header: 'Date',
      accessor: 'date_start', // accessor is the "key" in the data

      Cell: ({cell: {value}, row}) => {
        return (
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-60px me-5'>
              <span className='svg-icon svg-icon-primary svg-icon-3x'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='21'
                  fill='none'
                  viewBox='0 0 20 21'
                >
                  <path
                    fill='currentColor'
                    d='M19 3.4c-.6 0-1 .4-1 1v4h-4v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H8v-4c0-.6-.4-1-1-1s-1 .4-1 1v4H2v-4c0-.6-.4-1-1-1s-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-15c0-.6-.4-1-1-1zm-1 7v3h-4v-3h4zm-6 0v3H8v-3h4zm0 5v3H8v-3h4zm-6-5v3H2v-3h4zm-4 5h4v3H2v-3zm12 3v-3h4v3h-4z'
                    opacity='0.3'
                  ></path>
                  <path
                    fill='currentColor'
                    d='M19 .4H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z'
                  ></path>
                </svg>
              </span>
            </div>

            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
                {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
              </span>
              <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
                {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: 'E.Sales',
      accessor: 'date_end',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
            {dayjs(value).format('MMMM')} {dayjs(value).format('DD')} -{' '}
            {dayjs(row.original.date_end).format('DD')} , {dayjs(value).format('YYYY')}
          </span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            {dayjs(value).format('LTS')} - {dayjs(row.original.date_end).format('LTS')}
          </span>
        </>
      ),
    },
    {
      Header: 'Entries',
      accessor: 'occurrences',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>{value}</span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            {row.original.hours_selling} Hours
          </span>
        </>
      ),
    },
    {
      Header: 'expenses_info',
      accessor: 'expenses_info',

    },

    {
      Header: 'G.Profit',
      accessor: 'gross_profit',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
            <>
              {isNegative(value) ? (
                <span className='text-danger'>
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}
                </span>
              ) : (
                <span>
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}{' '}
                </span>
              )}
            </>
          </span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            <span className='badge badge-light-danger'>
              {addCommas(row.original.gross_expenses.toFixed(2))} {CURRENCY_APP}
            </span>
          </span>
        </>
      ),
    },
    {
      Header: 'N.Profit',
      accessor: 'net_profit',

      Cell: ({cell: {value}, row}) => (
        <>
          {isNegative(value) ? (
            <span className='text-nowrap'>
              {isNegative(row.original.profit_trend) ? (
                <i className='fa fa-arrow-down text-danger'></i>
              ) : row.original.profit_trend === 0 ? (
                <i className='fa fa-arrow-up text-primary'></i>
              ) : (
                <i className='fa fa-arrow-up text-success'></i>
              )}{' '}
              <span className='badge badge-light-danger'>
                <span className='text-nowrap fs-7'>
                  {' '}
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}
                </span>
              </span>
            </span>
          ) : (
            <span className='text-nowrap'>
              {isNegative(row.original.profit_trend) ? (
                <i className='fa fa-arrow-down text-danger'></i>
              ) : row.original.profit_trend === 0 ? (
                <i className='fa fa-arrow-up text-primary'></i>
              ) : (
                <i className='fa fa-arrow-up text-success'></i>
              )}{' '}
              <span className='badge badge-light-success'>
                <span className='text-nowrap fs-7'>
                  {' '}
                  {addCommas(value.toFixed(2))} {CURRENCY_APP}
                </span>
              </span>
            </span>
          )}
        </>
      ),
    },
  ]
  const columndata6: ReadonlyArray<
    Column<{
      expense_id: number
      expense_amount: number
      expense_name: string
      date_expense_made: string
    }>
  > = [
    {
      Header: 'id',
      accessor: 'expense_id',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
        </>
      ),
    },

    {
      Header: 'Date',
      accessor: 'date_expense_made',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
            {dayjs(value).format('LL')}
          </span>
          <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
            {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
          </span>
        </>
      ),
    },
    {
      Header: 'Name',
      accessor: 'expense_name',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.expense_name}>
            {truncate(row.original.expense_name, 20)}
          </span>
        </>
      ),
    },

    {
      Header: 'Amount',
      accessor: 'expense_amount',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {' '}
            {addCommas(value.toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
  ]

  //less than 730 but more than 420

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Profit or Loss</PageTitle>
      {/* begin::Row */}
      {/* begin::Row */}
      {showDashboard && (
      <div className='row g-5 g-xl-8'>
        {/* begin::Col */}

        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-xl-8'
            chartColor='primary'
            chartHeight='120px'
            cardName='G.Profit'
            chartName='Gross Profit'
            statusnow={statusnow}
            statusnow2={statusnow2}
            yaxisHeight={
              Math.abs(Math.max(...gross_profit_or_loss))
            }
            chartCategories={gross_profit_or_loss_date2}
            chartData={gross_profit_or_loss2}
            values={
              <>
                <div className='fs-2 fw-bolder d-block '>
                  <CountUp
                    className='text-primary'
                    end={gross_profit_or_loss[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
                </div>
              </>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {gross_profit_or_loss[1] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {gross_profit_or_loss_date[1]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={gross_profit_or_loss[1]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {gross_profit_or_loss[2] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {gross_profit_or_loss_date[2]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={gross_profit_or_loss[2]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-xl-8'
            chartColor='danger'
            chartHeight='120px'
            cardName='G.Expenses'
            chartName='Gross Expenses'
            statusnow={statusnow}
            statusnow2={statusnow2}
            yaxisHeight={Math.abs(Math.max(...expenses_made))}
            chartCategories={expenses_made_date2}
            chartData={expenses_made2}
            values={
              <div className='fs-2 fw-bolder'>
                <CountUp
                  className='text-danger'
                  end={expenses_made[0]}
                  duration={2}
                  decimals={2}
                  separator=','
                />{' '}
                <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
              </div>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {expenses_made[1] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {expenses_made_date[1]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={expenses_made[1]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {expenses_made[2] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {expenses_made_date[2]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={expenses_made[2]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-5 mb-xl-8'
            chartColor={`${isNegative(profit_or_loss[0]) ? 'danger' : 'success'}`}
            chartHeight='120px'
            statusnow={statusnow}
            statusnow2={statusnow2}
            cardName={`${isNegative(profit_or_loss[0]) ? 'N.Loss' : 'N.Profit'}`}
            chartName={`${isNegative(profit_or_loss[0]) ? 'Net Loss' : 'Net Profit'}`}
            yaxisHeight={
              Math.abs(Number(Math.max(...profit_or_loss).toFixed(0))) +
              Math.abs(Number(Math.min(...profit_or_loss).toFixed(0)))
            }
            chartCategories={profit_or_loss_date2}
            chartData={profit_or_loss2}
            values={
              <>
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className={`${isNegative(profit_or_loss[0]) ? 'text-danger' : 'text-success'}`}
                    end={profit_or_loss[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup
                    className={`${
                      isNegative(profit_or_loss[0]) ? 'fs-6 text-danger' : 'fs-6 text-success'
                    }`}
                  >
                    {CURRENCY_APP}
                  </sup>
                </div>
              </>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {profit_or_loss[1] ? (
                        <tr>
                          <td>
                            <span
                              className={`${
                                isNegative(profit_or_loss[1])
                                  ? 'badge badge-light-danger'
                                  : 'badge badge-light-success'
                              }`}
                            >
                              {profit_or_loss_date[1]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={profit_or_loss[1]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {profit_or_loss[2] ? (
                        <tr>
                          <td>
                            <span
                              className={`${
                                isNegative(profit_or_loss[2])
                                  ? 'badge badge-light-danger'
                                  : 'badge badge-light-success'
                              }`}
                            >
                              {profit_or_loss_date[2]}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={profit_or_loss[2]}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}
      </div>)}
      {/* end::Row */}

      <KTCard>
        <KTCardBody className='py-4'>
        
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Daily Income</h3>
              </div>
            </div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                {/* begin::Search */}
                <div className='d-flex align-items-center position-relative my-1'>
                  <a href='#' onClick={handlesearchKeyDown2}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'
                    />
                  </a>
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-14'
                    placeholder='Search Items'
                    ref={myRefsearch}
                    // value={searchTitle}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}
                  />
                </div>
                {/* end::Search */}
              </div>
            </div>
          </div>

          <div className='row mt-5 mb-5'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>

            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center text-nowrap'>
                  <span className='text-muted fw-bolder fs-7 text-uppercase gs-0'>INSIGHTS</span>
                  <span className='h-50px border-gray-200 border-start mx-2'></span>
                  <div className='d-flex justify-content-start flex-column'>
                    <span className='fw-bold d-block fs-7 text-muted'>
                      <table>
                        <tbody>
                          {profitTrend.direction ? (
                            <tr>
                              <td>NP.TREND</td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <span className={`${profitTrend.textColor}`}>
                                  <span className='text-uppercase fw-bolder'>
                                    {profitTrend.direction}
                                  </span>{' '}
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}

                          {dailyprofitlossssuccess2 ? (
                            <tr>
                              <td>NP.AVERAGE</td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <span className='text-uppercase fw-bolder'>
                                  <CountUp
                                    className='text-primary'
                                    end={
                                      Number(
                                        tabledata3.reduce(
                                          (acc: any, curr: any) => acc + curr.net_profit,
                                          0
                                        )
                                      ) / tabledata3.length
                                    }
                                    duration={2}
                                    decimals={2}
                                    separator=','
                                  />{' '}
                                  <sup>{CURRENCY_APP}</sup>
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}
                        </tbody>
                      </table>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Maintable
            tabledata={dailyprofitlossssuccess ? tabledata : []}
            startlimit={startlimit}
            hiddencolumnsmade={hiddencolumnsmade}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            pageCount={pageCount}
            setPageCount={setPageCount}
            setPaginationsize={setPaginationsize}
            columndata={
              onlyWidth <= 576
                ? columndata3
                : onlyWidth > 576 && onlyWidth <= 768
                ? columndata5
                : columndata1
            }
            tabledata2={tabledata}
            columndata2={
              onlyWidth <= 576
                ? columndata4
                : onlyWidth > 576 && onlyWidth <= 768
                ? columndata6
                : columndata2
            }
            table1loaded={dailyprofitlossstatus === 'success'}
            table2loaded={dailyprofitlossstatus === 'success'}
            tablename={tablename}
            tablelength={dailyprofitlossstatus === 'success' ? tabledatalength : 0}
            filteredsubdata={filteredsubdata}
            filteredtablesubData={filteredtablesubData}
            setServersort={setServersort}
          />
        </KTCardBody>
      </KTCard>
    </>
  )
}

export default Home
